$(document).ready(function(){
  $('.inPage-burger').on('click', function (){
    $(this).toggleClass('open');
    $('.inPage-menu').toggleClass('open');

    if($('.inPage-menu').hasClass('open')) {
      $('.inPage-menu').css('margin-top', 'calc(-1 * (116px + '+$('.inPage-menu').outerHeight()+'px))');
      $('.inPage-menu').css('top', "calc(100vh - "+$('.inPage-menu').outerHeight()+"px - 76px)");
    } else {
      $('.inPage-menu').css('margin-top', 'calc(-1 * ('+$('.inPage-menu').outerHeight()+'px))');
    }       
  });
  $('.inPage-Nav').on('click', function (){
    $('.inPage-burger').toggleClass('open');
    $('.inPage-menu').toggleClass('open');
  });
});